export const PlusIcon = () => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M12 5V19" stroke="#A63494" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
			<path d="M5 12H19" stroke="#A63494" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	);
};
